import { TimerOutlined } from "@mui/icons-material";
import { styled } from "@mui/material";
import { memo } from "react";

const TimerIcon = ({ ...otherProps }) => {
  return <CustomTimerIcon {...otherProps} />;
};

export default memo(TimerIcon);

const CustomTimerIcon = styled(TimerOutlined)(props => ({
  fontSize: 14,
  color: props.theme.palette.grey[500],
}));
